import React, { useState, useEffect } from "react";
import { TextField, Button, MenuItem, Menu, Tooltip } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import removeUnderscores from "../../../../functions/removeUnderscores";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import SEFChangePage from "../../../components/ChangePage/SEFChangePage";
import TextFieldForObjectState from "../../../components/Questions/TextFields/TextFieldForObjectState";

import SelectFieldForObjectState from "../../../components/Questions/TextFields/SelectFieldForObjectState";
import CheckConditions from "../../../components/Questions/CheckConditions";
import DisplayTextField from "../../../components/Questions/DisplayTextField";
import getArrayOfQuestionsAndNeededToSubmit from "../../../components/Questions/GetUsefulArrays/getArrayOfQuestionsAndNeededToSubmit";
import { Arr_BasicInfo } from "../../../../arrays/SEF/Arr_BasicInfo";
import { Student_Get_One_Photo_From_MongoDB } from "../../../api/Student_Get_One_Photo_From_MongoDB";
import getPhotoGroup from "../../../../functions/getPhotoGroup";
import { handleFileInput } from "../../../components/Photos/handleFileInput";
import { Consultant_Get_One_Nested_Prop_From_MongoDB } from "../../../../Consultants/api/Consultant_Get_One_Nested_Prop_From_MongoDB";
import { ConsultantuseAuth } from "../../../../Consultants/security/ConsultantUseAuth";
import { Consultant_Get_One_Photo_From_MongoDB } from "../../../../Consultants/api/Consultant_Get_One_Photo_From_MongoDB";
import { Consultant_Update_To_MongoDB_By_ID } from "../../../../Consultants/api/Consultant_Update_To_MongoDB_By_ID";
import { Get_One_Choose_Fields_From_MongoDB } from "../../../../Consultants/api/Get_One_Choose_Fields_From_MongoDB";

function ViewSEFBasicInfo() {
  const { id } = useParams();

  let logoutStudent;
  let logoutConsultant;
  if (window.location.href.indexOf("Student") > -1) {
    logoutStudent = StudentuseAuth().logoutStudent;
  } else {
    logoutConsultant = ConsultantuseAuth().logoutConsultant;
  }

  const [formInfo, setformInfo] = useState({});

  //Get all questions for this page
  const { arrayOfQuestions, neededToSubmit } =
    getArrayOfQuestionsAndNeededToSubmit("BasicInfo", formInfo, Arr_BasicInfo);

  const isFormComplete = neededToSubmit.length === 0;

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  const [SEFProgress, setSEFProgress] = useState({
    BasicInfo: "",
  });
  const [obj_EC, setobj_EC] = useState({});
  const [obj_assignedEC, setobj_assignedEC] = useState({});
  const [StudentData, setStudentData] = useState({});

  useEffect(() => {
    //if the web page URL contains the string Student
    if (window.location.href.indexOf("Student") > -1) {
      Student_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        "BasicInfo",
        setformInfo,
        logoutStudent
      );
      Student_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        "SEFProgress",
        setSEFProgress,
        logoutStudent
      );
    } else {
      Consultant_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        "SEFProgress",
        setSEFProgress,
        logoutConsultant
      );
      Consultant_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        "BasicInfo",
        setformInfo,
        logoutConsultant
      );
      Get_One_Choose_Fields_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        { IPInfo: 1, SEFProgress: 1 },
        setStudentData,
        logoutConsultant
      );
    }
  }, []);

  useEffect(() => {
    //if the web page URL contains the string Student
    if (window.location.href.indexOf("Student") > -1) {
    } else {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        {},
        setobj_EC,
        logoutConsultant
      );
      if (StudentData && StudentData._id && StudentData._id.length === 24) {
        Get_One_Choose_Fields_From_MongoDB(
          "IP",
          "EC",
          StudentData.IPInfo?.EC_ID,
          { _id: 1, "MetaData.Agency_id": 1 },
          setobj_assignedEC,
          logoutConsultant
        );
      }
    }
  }, [StudentData]);

  let EC_Check_Permissions = false;
  if (
    localStorage.getItem("Consultant_id") === StudentData.IPInfo?.EC_ID ||
    (obj_EC.MetaData?.Admin === "Yes" &&
      obj_EC.MetaData?.Agency_id === obj_assignedEC.MetaData?.Agency_id)
  ) {
    EC_Check_Permissions = true;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleNumberChange = (value) => {
    setformInfo((prevData) => ({
      ...prevData,
      Number: value,
    }));
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Update_To_MongoDB_By_ID(
        {
          BasicInfo: formInfo,
          "SEFProgress.BasicInfo": "In_Progress",
        },
        "Registers_2025",
        "All",
        setStatus,
        localStorage.getItem("Student_id"),
        "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
        logoutStudent
      );
    } else {
      Consultant_Update_To_MongoDB_By_ID(
        {
          BasicInfo: formInfo,
          "SEFProgress.BasicInfo": "In_Progress",
        },
        "Registers_2025",
        "All",
        setStatus,
        id,
        logoutConsultant
      );
    }
    setPageButtonStatus(true);
  };

  const handleSubmit = () => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Update_To_MongoDB_By_ID(
        {
          BasicInfo: formInfo,
          "SEFProgress.BasicInfo": "Awaiting_Review",
        },
        "Registers_2025",
        "All",
        setStatus,
        localStorage.getItem("Student_id"),
        "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
        logoutStudent
      );
    } else {
      Consultant_Update_To_MongoDB_By_ID(
        {
          BasicInfo: formInfo,
          "SEFProgress.BasicInfo": "Awaiting_Review",
        },
        "Registers_2025",
        "All",
        setStatus,
        id,
        logoutConsultant
      );
    }
    setSEFProgress({
      BasicInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  //-------------------------Langauge Image--------------------------------
  const [Language_Image_2025, setLanguage_Image_2025] = useState({
    myFile: "",
  });

  function handlePhotoUpload(e, setState, State, Type, Group, id) {
    window.location.href.indexOf("Student") > -1
      ? handleFileInput(e, setState, State, Type, Group, id, "Student")
      : handleFileInput(e, setState, State, Type, Group, id, "Consultant");
  }

  useEffect(() => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Get_One_Photo_From_MongoDB(
        "Language_Image_2025",
        getPhotoGroup(id.slice(-1)),
        localStorage.getItem("Student_id"),
        setLanguage_Image_2025,
        logoutStudent
      );
    } else {
      Consultant_Get_One_Photo_From_MongoDB(
        "Language_Image_2025",
        getPhotoGroup(id.slice(-1)),
        id,
        setLanguage_Image_2025,
        logoutConsultant
      );
    }
  }, []);

  let Allowed_To_Upload = false;
  if (
    SEFProgress.BasicInfo !== "Complete" &&
    SEFProgress.BasicInfo !== "Awaiting_Review"
  ) {
    Allowed_To_Upload = true;
  }

  if (
    window.location.href.indexOf("Student") < 0 &&
    !EC_Check_Permissions &&
    (Object.keys(StudentData).length === 0 ||
      Object.keys(obj_EC).length === 0 ||
      Object.keys(obj_assignedEC).length === 0)
  ) {
    return (
      <div className="view-basic-info-container">
        <h1>Checking Access Permissions...</h1>
      </div>
    );
  } else if (
    window.location.href.indexOf("Student") < 0 &&
    !EC_Check_Permissions
  ) {
    return (
      <div className="view-basic-info-container">
        <h1>Access Denied</h1>
      </div>
    );
  } else {
    return (
      <div className="view-basic-info-container">
        <h1>Summer Information</h1>
        {SEFProgress &&
        SEFProgress.BasicInfo &&
        (SEFProgress.BasicInfo === "Complete" ||
          SEFProgress.BasicInfo === "Awaiting_Review") ? (
          <strong>
            If you need to make further changes, please contact InvestIN at
            info@investin.org or speak to your known contact
          </strong>
        ) : (
          ""
        )}
        <form className="view-basic-info-form">
          <h2>Student Basic Information</h2>
          {Array.from({ length: 3 }, (_, i) => i).map((i) => (
            <>
              <DisplayTextField
                formInfo={formInfo}
                handleChange={handleChange}
                Object={Arr_BasicInfo[i]}
              />
            </>
          ))}
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleNumberChange}
            Object={Arr_BasicInfo[3]}
          />
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleChange}
            Object={Arr_BasicInfo[4]}
          />
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleChange}
            Object={Arr_BasicInfo[5]}
          />
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleChange}
            Object={Arr_BasicInfo[6]}
          />
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleChange}
            Object={Arr_BasicInfo[7]}
          />
          <h2>Student Home Address</h2>
          {Array.from({ length: 4 }, (_, i) => i + 8).map((i) => (
            <>
              <DisplayTextField
                formInfo={formInfo}
                handleChange={handleChange}
                Object={Arr_BasicInfo[i]}
              />
            </>
          ))}
          <h2>Student Further Details</h2>
          {Array.from({ length: 9 }, (_, i) => i + 12).map((i) => (
            <>
              <DisplayTextField
                formInfo={formInfo}
                handleChange={handleChange}
                Object={Arr_BasicInfo[i]}
              />
            </>
          ))}
          <h2>Language</h2>
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleChange}
            Object={Arr_BasicInfo[21]}
          />
          <DisplayTextField
            formInfo={formInfo}
            handleChange={handleChange}
            Object={Arr_BasicInfo[22]}
          />
          {formInfo.primary_language_is_english_level &&
          (formInfo.primary_language_is_english_level ===
            "C2 (Advanced/Fluent)" ||
            formInfo.primary_language_is_english_level === "C1 (Advanced)" ||
            formInfo.primary_language_is_english_level ===
              "B2 (Upper Intermediate)") ? (
            <>
              <b>
                If you answered C2, C1 or B2, please upload proof of language
                level. If the student does not have a certificate showing their
                English language level, please ask the student to complete the
                15-minute{" "}
                <a href="https://www.efset.org/quick-check/" target="_blank">
                  Quick Check Test here
                </a>{" "}
                and take a screenshot image of the results. Then upload them
                below:
              </b>
              <div
                className=""
                style={{
                  width: "100%",
                  height: "auto",
                  display: "flex",
                  flex: "1",
                  flexDirection: "column",
                }}
              >
                <label>
                  <img
                    src={Language_Image_2025.myFile}
                    alt=""
                    className="maxheight300px maxwidth300px"
                    style={{ maxWidth: "300px", maxHeight: "300px" }}
                  ></img>
                </label>
                {Allowed_To_Upload ? (
                  <input
                    type="file"
                    lable="Image"
                    name="myFile"
                    id="file-upload"
                    accept=".jpeg, .png, .jpg"
                    onChange={(e) =>
                      handlePhotoUpload(
                        e,
                        setLanguage_Image_2025,
                        Language_Image_2025,
                        "Language_Image_2025",
                        getPhotoGroup(id.slice(-1)),
                        id
                      )
                    }
                  ></input>
                ) : (
                  <></>
                )}
              </div>
            </>
          ) : (
            <></>
          )}
          {window.location.href.indexOf("Student") > -1 ? (
            <SEFChangePage
              Page={"BasicInfo"}
              PageButtonStatus={PageButtonStatus}
            />
          ) : (
            <></>
          )}
          {isFormComplete ? (
            <></>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>
                    You can save this page at any point. To submit this page,
                    please complete the following questions first:
                  </th>
                </tr>
              </thead>
              <tbody>
                {neededToSubmit.map((Obj) => {
                  return (
                    <tr key={Obj.name}>
                      <td>{Obj.label}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          <h3>
            Once this page is completed and you have completed every question,
            please click "Submit" to complete the page and send it for review by
            InvestIN. Otherwise, click "Save" if you are not ready to complete
            the page and wish to return later to make changes
          </h3>
          <div className="view-basic-info-buttons">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveProgress}
              disabled={
                status ||
                (SEFProgress &&
                  SEFProgress.BasicInfo &&
                  (SEFProgress.BasicInfo === "Complete" ||
                    SEFProgress.BasicInfo === "Awaiting_Review")) ||
                Object.keys(formInfo).length === 0
              }
            >
              Save Progress
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSubmit}
              disabled={
                !isFormComplete ||
                status ||
                (SEFProgress &&
                  SEFProgress.BasicInfo &&
                  (SEFProgress.BasicInfo === "Complete" ||
                    SEFProgress.BasicInfo === "Awaiting_Review")) ||
                (formInfo.primary_language_is_english_level &&
                  (formInfo.primary_language_is_english_level ===
                    "C2 (Advanced/Fluent)" ||
                    formInfo.primary_language_is_english_level ===
                      "C1 (Advanced)" ||
                    formInfo.primary_language_is_english_level ===
                      "B2 (Upper Intermediate)") &&
                  Language_Image_2025.serverCheck !== "Yes") ||
                Object.keys(formInfo).length === 0
              }
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default ViewSEFBasicInfo;
